import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.groups.item');
import { OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';
import { TranslateService } from '@ngx-translate/core';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-groups-item',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.groups.item/view.scss */
:host ::ng-deep input::placeholder,
:host ::ng-deep select::placeholder,
:host ::ng-deep textarea::placeholder {
  color: #c5c9d0;
  opacity: 1;
}`],
})
export class PageKieraGroupsItemComponent implements OnInit {
    public groupId: number = 0;
    public group: any = null;

    // Tab
    public activeTab: string = 'summary';

    // Nodes tab
    public nodes: any[] = [];
    public nodeTotal: number = 0;
    public search: any = { text: '', status: '', page: 1, dump: 20 };
    public statusOptions: string[] = ['new', 'commissioning', 'ready', 'deploying', 'deployed', 'failed'];
    public bmcCredentialProfiles: any[] = [];

    // Node selection
    public selectedNodes: Set<number> = new Set();

    // Add Node modal
    public showAddNodeModal: boolean = false;
    public newNode: any = {};

    // Add Rack Device modal
    public showAddDeviceModal: boolean = false;
    public addingDevice: boolean = false;
    public editingDeviceId: number | null = null;
    public newDevice: any = {};
    public uploadingRackItemKey: string = '';
    public deviceTypes: any[] = [
        { value: 'switch', label: 'Network Switch' },
        { value: 'router', label: 'Router' },
        { value: 'storage', label: 'Storage' },
        { value: 'firewall', label: 'Firewall' },
        { value: 'pdu', label: 'PDU' },
        { value: 'patch-panel', label: 'Patch Panel' },
        { value: 'other', label: 'Other' }
    ];

    // Import Guide modals
    public showImportGuide: boolean = false;
    public showRackPositionGuide: boolean = false;
    public importing: boolean = false;
    public importResult: any = null;

    // Rack View tab
    public rackLayout: any[] = [];
    public racksExpanded: boolean = true;
    public rackMinimized: boolean = false;
    public selectedNode: any = null;
    public showNodeDetail: boolean = false;

    // Fullscreen Rack View
    public isFullscreen: boolean = false;
    public fsScale: number = 0.8;
    public fsTranslateX: number = 0;
    public fsTranslateY: number = 0;
    private fsDragging: boolean = false;
    private fsDragStartX: number = 0;
    private fsDragStartY: number = 0;
    private fsStartTransX: number = 0;
    private fsStartTransY: number = 0;

    // Node hover tooltip
    public hoverNode: any = null;
    public hoverNodeX: number = 0;
    public hoverNodeY: number = 0;
    private hoverTimeout: any = null;

    // Rack side panel (View Detail)
    public showRackPanel: boolean = false;
    public panelRack: any = null;

    // Node Edit modal (edit node details from groups page)
    public showNodeEditModal: boolean = false;
    public editNodeData: any = {};
    public savingNodeEdit: boolean = false;

    // Theme
    public fsTheme: string = 'light'; // 'dark' | 'light'

    // Edit Mode
    public isEditMode: boolean = false;
    public editHasChanges: boolean = false;
    public editSaving: boolean = false;
    public editingNode: any = null;       // 현재 편집 중인 노드
    public editNodeRack: string = '';     // 편집 폼 rack 값
    public editNodeUnitOrder: string = ''; // 편집 폼 Unit Order 값
    private editedNodes: Map<number, { rack: string, unitOrder: string }> = new Map();
    private editedDevices: Map<number, { rack: string, unitOrder: string }> = new Map();

    // Canvas Edit Mode (absolute positioning for racks)
    public canvasRacks: any[] = [];
    public hoverRackId: string | null = null; // Edit mode rack hover overlay
    private rackDragging: boolean = false;
    private dragRackId: string | null = null;
    private rackDragStartX: number = 0;
    private rackDragStartY: number = 0;
    private rackStartLeft: number = 0;
    private rackStartTop: number = 0;

    // Node drag & drop between racks
    public nodeDragging: boolean = false;
    public dragNode: any = null;
    public dragItemType: string = 'node';
    public dragSourceRack: string = '';
    public dragOverRackId: string | null = null;
    public dragOverUnitOrder: number = 1;
    private nodeDragStartX: number = 0;
    private nodeDragStartY: number = 0;
    public nodeDragX: number = 0;
    public nodeDragY: number = 0;

    constructor(@Inject( Service) public service: Service,@Inject( TranslateService)  private translate: TranslateService) { }

    public async ngOnInit() {
        await this.service.init();
        this.groupId = WizRoute.segment.id;
        this.activeTab = 'summary';
        await this.loadBmcCredentials();
        await this.loadGroup();
        await this.loadNodes();
        await this.service.render();
    }

    public async loadGroup() {
        const { code, data } = await wiz.call("get", { id: this.groupId });
        if (code !== 200) {
            this.service.href('/kiera/groups');
            return;
        }
        this.group = data;
    }

    public async loadBmcCredentials() {
        const { code, data } = await wiz.call('bmc_credentials');
        this.bmcCredentialProfiles = code === 200 && Array.isArray(data?.rows) ? data.rows : [];
    }

    // ===== Tab =====
    public async switchTab(tab: string) {
        if (!['summary', 'nodes', 'users'].includes(tab) || (tab === 'users' && !this.canManageResourceUsers())) return;
        this.activeTab = tab;
        if (tab === 'summary') {
            await this.loadGroup();
        } else if (tab === 'nodes') {
            await this.loadNodes(this.search.page);
        }
        await this.service.render();
    }

    // ===== Nodes Tab =====
    public async loadNodes(page: number = 1) {
        this.search.page = page;
        const { code, data } = await wiz.call("nodes", {
            group_id: this.groupId,
            text: this.search.text,
            status: this.search.status,
            page: this.search.page,
            dump: this.search.dump
        });
        if (code === 200) {
            this.nodes = data.rows || [];
            this.nodeTotal = data.total || 0;
        }
        await this.service.render();
    }

    public async filterStatus(status: string) {
        this.search.status = this.search.status === status ? '' : status;
        await this.loadNodes();
    }

    // ===== Node Selection =====
    public toggleNodeSelection(id: number) {
        if (this.selectedNodes.has(id)) this.selectedNodes.delete(id);
        else this.selectedNodes.add(id);
        this.service.render();
    }

    public isNodeSelected(id: number): boolean {
        return this.selectedNodes.has(id);
    }

    public toggleSelectAll() {
        if (this.selectedNodes.size === this.nodes.length) {
            this.selectedNodes.clear();
        } else {
            this.nodes.forEach(n => this.selectedNodes.add(n.id));
        }
        this.service.render();
    }

    public get allSelected(): boolean {
        return this.nodes.length > 0 && this.selectedNodes.size === this.nodes.length;
    }

    // ===== Add Node =====
    public openAddNodeModal() {
        this.newNode = {
            name: '', rack: '1', unit_order: '', unit_size: 1,
            bmc_credential_id: '', bmc_ip: '', bmc_mac: '',
            mac_address: '', ip_address: '', os: '', cpu_spec: '', ram_spec: '', disk_spec: '',
            gpu1: '', gpu2: '', lan1: '', lan2: '', lan3: '', lan4: '', credentials: '', notes: ''
        };
        this.showAddNodeModal = true;
        this.service.render();
    }

    public async submitAddNode() {
        if (!this.newNode.name?.trim()) return;
        this.newNode.group_id = this.groupId;
        const { code, data } = await wiz.call("add_node", { data: JSON.stringify(this.newNode) });
        if (code === 200) {
            this.showAddNodeModal = false;
            await this.loadNodes();
        } else {
            alert(data?.message || 'Failed to add node');
        }
    }

    // ===== Add Rack Device =====
    public openAddDeviceModal(rack: any, event?: Event) {
        if (event) event.stopPropagation();
        const suggestedUnitOrder = this.findAvailableUnitOrder(rack, 1, 1);
        this.editingDeviceId = null;
        this.newDevice = {
            name: '',
            device_type: 'switch',
            rack: rack.rack_id,
            unit_order: suggestedUnitOrder || 1,
            unit_size: 1,
            notes: ''
        };
        this.showAddDeviceModal = true;
        this.hoverRackId = null;
        this.service.render();
    }

    public openEditDeviceModal(device: any, event?: Event) {
        if (event) event.stopPropagation();
        this.editingDeviceId = device.id;
        this.newDevice = {
            id: device.id,
            name: device.name || '',
            device_type: device.device_type || 'switch',
            rack: String(device.rack || '1'),
            unit_order: this.itemUnitOrder(device) || 1,
            unit_size: this.itemUnitSize(device),
            notes: device.notes || ''
        };
        this.showAddDeviceModal = true;
        this.service.render();
    }

    public closeAddDeviceModal() {
        if (this.addingDevice) return;
        this.showAddDeviceModal = false;
        this.editingDeviceId = null;
        this.newDevice = {};
        this.service.render();
    }

    public async submitAddDevice() {
        if (this.addingDevice || !this.newDevice.name?.trim()) return;
        this.addingDevice = true;
        this.newDevice.group_id = this.groupId;
        await this.service.render();

        const action = this.editingDeviceId ? "update_device" : "add_device";
        const { code, data } = await wiz.call(action, {
            data: JSON.stringify(this.newDevice)
        });
        this.addingDevice = false;

        if (code === 200 && data?.device) {
            if (this.editingDeviceId) this.replaceLocalRackDevice(data.device);
            else this.appendLocalRackDevice(data.device);
            this.showAddDeviceModal = false;
            this.editingDeviceId = null;
            this.newDevice = {};
        } else {
            alert(data?.message || `Failed to ${this.editingDeviceId ? 'update' : 'add'} rack device`);
        }
        await this.service.render();
    }

    // ===== Import CSV =====
    public openImportGuide() {
        this.showImportGuide = true;
        this.importResult = null;
        this.service.render();
    }

    public triggerCsvImport() {
        this.showImportGuide = false;
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.csv';
        input.onchange = async (e: any) => {
            const file = e.target.files[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = async (ev: any) => {
                this.importing = true;
                await this.service.render();
                const { code, data } = await wiz.call("import_csv", {
                    group_id: this.groupId,
                    file_data: ev.target.result
                });
                this.importing = false;
                if (code === 200) {
                    this.importResult = data;
                    const msg = `Import complete: ${data.success || 0} nodes created` +
                        (data.failed?.length ? `, ${data.failed.length} failed` : '');
                    alert(msg);
                    await this.loadNodes();
                } else {
                    alert(data?.message || 'Import failed');
                }
                await this.service.render();
            };
            reader.readAsText(file);
        };
        input.click();
    }

    // ===== Import Rack Position =====
    public openRackPositionGuide() {
        this.showRackPositionGuide = true;
        this.service.render();
    }

    public triggerRackPositionImport() {
        this.showRackPositionGuide = false;
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.csv';
        input.onchange = async (e: any) => {
            const file = e.target.files[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = async (ev: any) => {
                this.importing = true;
                await this.service.render();
                const { code, data } = await wiz.call("import_rack_position", {
                    group_id: this.groupId,
                    file_data: ev.target.result
                });
                this.importing = false;
                if (code === 200) {
                    const msg = `Position update: ${data.updated || 0} updated` +
                        (data.failed?.length ? `, ${data.failed.length} failed` : '');
                    alert(msg);
                    await this.loadNodes();
                    if (this.rackLayout.length > 0) await this.loadRackLayout();
                } else {
                    alert(data?.message || 'Import failed');
                }
                await this.service.render();
            };
            reader.readAsText(file);
        };
        input.click();
    }

    // ===== Export CSV =====
    public async exportCsv() {
        const { code, data } = await wiz.call("export_csv", {
            group_id: this.groupId,
            status: this.search.status,
            text: this.search.text
        });
        if (code === 200 && data.csv_content) {
            const blob = new Blob([data.csv_content], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${this.group?.name || 'nodes'}-${new Date().toISOString().slice(0, 10)}.csv`;
            a.click();
            URL.revokeObjectURL(url);
        }
    }

    // ===== Delete Nodes =====
    public async deleteSelectedNodes() {
        if (this.selectedNodes.size === 0) return;
        if (!confirm(this.translate.instant('page.groups.item.confirm_delete_selected', { count: this.selectedNodes.size }))) return;
        const ids = Array.from(this.selectedNodes);
        const { code, data } = await wiz.call("delete_nodes", { ids: JSON.stringify(ids) });
        if (code === 200) {
            const failed = (data?.results || []).filter((row: any) => !row.success);
            this.selectedNodes = new Set(failed.map((row: any) => Number(row.id)).filter((id: number) => id > 0));
            await this.loadNodes();
            if (failed.length) {
                alert(this.translate.instant('gap.groups.partial', { count: failed.length }) + '\n' +
                    failed.slice(0, 20).map((row: any) => '#' + row.id + ': ' + row.message).join('\n'));
            }
        } else {
            alert(data?.message || 'Delete failed');
        }
    }

    public getStatusBadge(status: string): string {
        switch (status) {
            case 'new': return 'bg-zinc-100 text-zinc-600';
            case 'ready': return 'bg-green-100 text-green-700';
            case 'deploying': return 'bg-blue-100 text-blue-700';
            case 'deployed': return 'bg-emerald-100 text-emerald-700';
            case 'error':
            case 'failed': return 'bg-red-100 text-red-700';
            case 'commissioning': return 'bg-purple-100 text-purple-700';
            case 'on': return 'bg-green-100 text-green-700';
            case 'off': return 'bg-zinc-100 text-zinc-600';
            default: return 'bg-zinc-100 text-zinc-600';
        }
    }

    // ===== Rack View Tab =====
    public async loadRackLayout() {
        const { code, data } = await wiz.call("rack_layout", { group_id: this.groupId });
        if (code === 200) {
            this.rackLayout = data || [];
            // Always initialize canvasRacks for both view & edit mode
            this.initCanvasRacks();
        }
        await this.service.render();
    }

    private itemUnitOrder(item: any): number {
        return parseInt(item?.unit_order ?? item?.unit) || 0;
    }

    private itemUnitSize(item: any): number {
        return Math.max(1, parseInt(item?.unit_size ?? item?.rack_size) || 1);
    }

    private applyLocalUnitLayout(rack: any): any[] {
        const items = [
            ...(rack.nodes || []).map((item: any) => {
                item.item_type = 'node';
                return item;
            }),
            ...(rack.devices || []).map((item: any) => {
                item.item_type = 'device';
                return item;
            })
        ].sort((a: any, b: any) => {
            const aOrder = this.itemUnitOrder(a) > 0 ? this.itemUnitOrder(a) : 43;
            const bOrder = this.itemUnitOrder(b) > 0 ? this.itemUnitOrder(b) : 43;
            const orderDiff = aOrder - bOrder;
            if (orderDiff !== 0) return orderDiff;
            if (a.item_type !== b.item_type) return a.item_type === 'node' ? -1 : 1;
            return (parseInt(a.id) || 0) - (parseInt(b.id) || 0);
        });

        let extraUnits = 0;
        for (const item of items) {
            const unitOrder = this.itemUnitOrder(item);
            const unitSize = this.itemUnitSize(item);
            item.unit_order = unitOrder;
            item.unit_size = unitSize;
            if (unitOrder < 1) {
                item.unit_start = 0;
                item.unit_end = 0;
                continue;
            }
            item.unit_start = unitOrder + extraUnits;
            item.unit_end = item.unit_start + unitSize - 1;
            extraUnits += unitSize - 1;
        }
        return items;
    }

    public getRackSlots(rack: any): any[] {
        const items = this.applyLocalUnitLayout(rack);
        const occupied = new Set<number>();
        const starts = new Map<number, any[]>();
        items.forEach((item: any) => {
            const unitStart = parseInt(item.unit_start) || 0;
            const unitSize = this.itemUnitSize(item);
            if (unitStart < 1 || unitStart > 42) return;
            if (!starts.has(unitStart)) starts.set(unitStart, []);
            starts.get(unitStart)?.push(item);
            for (let current = unitStart; current <= Math.min(42, unitStart + unitSize - 1); current++) {
                occupied.add(current);
            }
        });

        const slots: any[] = [];
        let i = 1;
        while (i <= 42) {
            if (starts.has(i)) {
                for (const item of starts.get(i) || []) {
                    const unitSize = this.itemUnitSize(item);
                    const slot = {
                        type: item.item_type,
                        unit: i,
                        unitOrder: this.itemUnitOrder(item),
                        endUnit: Math.min(42, i + unitSize - 1),
                        unitSize,
                        rackSize: unitSize
                    };
                    if (item.item_type === 'device') slots.push({ ...slot, device: item });
                    else slots.push({ ...slot, node: item });
                }
                i++;
            } else if (occupied.has(i)) {
                i++;
            } else {
                let start = i;
                while (i <= 42 && !occupied.has(i) && !starts.has(i)) i++;
                slots.push({ type: 'empty', start, end: i - 1, count: i - start });
            }
        }
        // Rack units are numbered bottom-up: render U42 at the top and U1 at the bottom.
        return slots.reverse();
    }

    public getNodeStatusStyle(status: string): any {
        switch (status) {
            case 'new': return { bg: 'bg-zinc-100 border-zinc-300', dot: 'bg-zinc-500', text: 'text-zinc-600' };
            case 'ready': return { bg: 'bg-green-100 border-green-300', dot: 'bg-green-500', text: 'text-green-700' };
            case 'deployed': return { bg: 'bg-blue-100 border-blue-300', dot: 'bg-blue-500', text: 'text-blue-700' };
            case 'deploying': return { bg: 'bg-yellow-100 border-yellow-300', dot: 'bg-yellow-500', text: 'text-yellow-700' };
            case 'error':
            case 'failed': return { bg: 'bg-red-100 border-red-300', dot: 'bg-red-500', text: 'text-red-700' };
            case 'commissioning': return { bg: 'bg-purple-100 border-purple-300', dot: 'bg-purple-500', text: 'text-purple-700' };
            default: return { bg: 'bg-zinc-100 border-zinc-300', dot: 'bg-zinc-400', text: 'text-zinc-600' };
        }
    }

    public getDeviceStyle(deviceType: string): any {
        switch (deviceType) {
            case 'router': return { bg: 'bg-indigo-100 border-indigo-300', dot: 'bg-indigo-500', text: 'text-indigo-700' };
            case 'storage': return { bg: 'bg-purple-100 border-purple-300', dot: 'bg-purple-500', text: 'text-purple-700' };
            case 'firewall': return { bg: 'bg-rose-100 border-rose-300', dot: 'bg-rose-500', text: 'text-rose-700' };
            case 'pdu': return { bg: 'bg-amber-100 border-amber-300', dot: 'bg-amber-500', text: 'text-amber-700' };
            case 'patch-panel': return { bg: 'bg-teal-100 border-teal-300', dot: 'bg-teal-500', text: 'text-teal-700' };
            case 'other': return { bg: 'bg-zinc-100 border-zinc-300', dot: 'bg-zinc-500', text: 'text-zinc-700' };
            default: return { bg: 'bg-cyan-100 border-cyan-300', dot: 'bg-cyan-500', text: 'text-cyan-700' };
        }
    }

    public getDeviceIcon(deviceType: string): string {
        switch (deviceType) {
            case 'router': return 'bx-wifi';
            case 'storage': return 'bx-data';
            case 'firewall': return 'bx-shield-quarter';
            case 'pdu': return 'bx-plug';
            case 'patch-panel': return 'bx-git-branch';
            default: return 'bx-network-chart';
        }
    }

    public rackUnitLabel(item: any): string {
        const unitStart = parseInt(item?.unit_start) || this.itemUnitOrder(item);
        const unitSize = this.itemUnitSize(item);
        const unitEnd = parseInt(item?.unit_end) || (unitStart + unitSize - 1);
        return unitSize > 1 ? `U${unitStart}-U${unitEnd}` : `U${unitStart}`;
    }

    public getRackItemBackground(item: any): string {
        if (!item) return '';
        const itemType = this.isRackDevice(item) ? 'device' : 'node';
        const filename = itemType === 'device' ? item.image : item.rack_image;
        if (!filename) return '';
        const url = `/wiz/api/page.kiera.groups.item/rack_item_image?item_type=${itemType}&item_id=${item.id}&v=${encodeURIComponent(filename)}`;
        return `linear-gradient(rgba(255,255,255,.68), rgba(255,255,255,.68)), url("${url}")`;
    }

    public async uploadRackItemImage(item: any, itemType: string, event?: Event) {
        if (event) event.stopPropagation();
        const key = `${itemType}:${item.id}`;
        if (this.uploadingRackItemKey === key) return;
        const files: any = await this.service.file.select({
            accept: 'image/png,image/jpeg,image/webp',
            multiple: false
        });
        const file = files && files.length ? files[0] : null;
        if (!file) return;
        if (file.size > 5 * 1024 * 1024) {
            alert('Image file must be 5 MB or smaller.');
            return;
        }

        this.uploadingRackItemKey = key;
        await this.service.render();
        const form = new FormData();
        form.append('file', file);
        form.append('item_type', itemType);
        form.append('item_id', String(item.id));
        const response: any = await this.service.file.upload(
            '/wiz/api/page.kiera.groups.item/upload_rack_item_image',
            form
        );
        this.uploadingRackItemKey = '';

        if (response?.code === 200 && response?.data?.image) {
            this.updateLocalRackItemImage(itemType, item.id, response.data.image);
        } else {
            alert(response?.data?.message || response?.message || 'Failed to upload image');
        }
        await this.service.render();
    }

    private updateLocalRackItemImage(itemType: string, itemId: number, filename: string) {
        const field = itemType === 'device' ? 'image' : 'rack_image';
        const collection = itemType === 'device' ? 'devices' : 'nodes';
        for (const rack of this.rackLayout) {
            const item = (rack[collection] || []).find((entry: any) => entry.id === itemId);
            if (item) item[field] = filename;
        }
        for (const rack of this.canvasRacks) {
            const item = (rack[collection] || []).find((entry: any) => entry.id === itemId);
            if (item) item[field] = filename;
        }
        if (this.selectedNode?.id === itemId && itemType === 'node') this.selectedNode[field] = filename;
        if (this.panelRack) {
            const item = (this.panelRack[collection] || []).find((entry: any) => entry.id === itemId);
            if (item) item[field] = filename;
        }
    }

    public isRackDevice(item: any): boolean {
        return item?.item_type === 'device';
    }

    public openNodeDetail(node: any) {
        this.hoverNode = null; // Clear tooltip
        this.selectedNode = node;
        this.showNodeDetail = true;
        this.service.render();
    }

    public closeNodeDetail() {
        this.selectedNode = null;
        this.showNodeDetail = false;
        this.service.render();
    }

    // Node Edit Modal (edit node details)
    public openNodeEditModal(node: any, event?: Event) {
        if (event) event.stopPropagation();
        this.editNodeData = {
            ...node,
            unit_order: this.itemUnitOrder(node),
            unit_size: this.itemUnitSize(node)
        };
        this.showNodeEditModal = true;
        this.showNodeDetail = false; // Close detail modal if open
        this.service.render();
    }

    public closeNodeEditModal() {
        this.showNodeEditModal = false;
        this.editNodeData = {};
        this.service.render();
    }

    public async saveNodeEdit() {
        if (this.savingNodeEdit) return;
        this.savingNodeEdit = true;
        await this.service.render();
        const { code, data } = await wiz.call("update_node", { data: JSON.stringify(this.editNodeData) });
        this.savingNodeEdit = false;
        if (code === 200) {
            this.showNodeEditModal = false;
            await this.loadNodes();
            if (this.rackLayout.length > 0) await this.loadRackLayout();
        } else {
            alert(data?.message || 'Failed to update node');
        }
        await this.service.render();
    }

    // ===== Fullscreen Rack View =====
    public openFullscreen() {
        this.isFullscreen = true;
        this.fsScale = 0.8;
        this.fsTranslateX = 0;
        this.fsTranslateY = 0;
        this.service.render();
        // ESC key listener
        document.addEventListener('keydown', this._fsEscHandler);
    }

    public closeFullscreen() {
        this.isFullscreen = false;
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        this.hoverTimeout = null;
        this.hoverNode = null;
        this.service.render();
        document.removeEventListener('keydown', this._fsEscHandler);
    }

    private _fsEscHandler = (e: KeyboardEvent) => {
        if (e.key === 'Escape') this.closeFullscreen();
    };

    public fsZoomIn() {
        this.fsScale = Math.min(3, this.fsScale + 0.15);
        this.service.render();
    }

    public fsZoomOut() {
        this.fsScale = Math.max(0.2, this.fsScale - 0.15);
        this.service.render();
    }

    public fsResetZoom() {
        this.fsScale = 0.8;
        this.fsTranslateX = 0;
        this.fsTranslateY = 0;
        this.service.render();
    }

    public fsOnWheel(event: WheelEvent) {
        event.preventDefault();
        // Scroll (pan) instead of zoom
        this.fsTranslateX -= event.deltaX || 0;
        this.fsTranslateY -= event.deltaY || 0;
        this.service.render();
    }

    public fsMouseDown(event: MouseEvent) {
        // Only pan on background (not on rack cards)
        if ((event.target as HTMLElement).closest('.rack-card')) return;
        this.fsDragging = true;
        this.fsDragStartX = event.clientX;
        this.fsDragStartY = event.clientY;
        this.fsStartTransX = this.fsTranslateX;
        this.fsStartTransY = this.fsTranslateY;
    }

    public fsMouseMove(event: MouseEvent) {
        if (!this.fsDragging) return;
        this.fsTranslateX = this.fsStartTransX + (event.clientX - this.fsDragStartX);
        this.fsTranslateY = this.fsStartTransY + (event.clientY - this.fsDragStartY);
        this.service.render();
    }

    public fsMouseUp() {
        this.fsDragging = false;
    }

    public get fsTransform(): string {
        return `translate(${this.fsTranslateX}px, ${this.fsTranslateY}px) scale(${this.fsScale})`;
    }

    public get fsZoomPercent(): number {
        return Math.round(this.fsScale * 100);
    }

    // Minimap calculations
    public get minimapRacks(): any[] {
        if (!this.rackLayout || this.rackLayout.length === 0) return [];
        // Use saved canvas positions if available, otherwise sequential layout
        const hasPositions = this.rackLayout.some((r: any) => r.canvas_x != null && r.canvas_y != null);
        if (hasPositions) {
            // Find bounds to scale minimap
            let maxX = 0, maxY = 0;
            this.rackLayout.forEach((r: any) => {
                const x = r.canvas_x || 0;
                const y = r.canvas_y || 0;
                if (x + 260 > maxX) maxX = x + 260;
                if (y + 400 > maxY) maxY = y + 400;
            });
            const scaleX = maxX > 0 ? 180 / maxX : 1;
            const scaleY = maxY > 0 ? 80 / maxY : 1;
            const scale = Math.min(scaleX, scaleY, 1);
            return this.rackLayout.map((rack: any) => {
                return {
                    ...rack,
                    left: 5 + (rack.canvas_x || 0) * scale,
                    top: 5 + (rack.canvas_y || 0) * scale
                };
            });
        }
        return this.rackLayout.map((rack: any, idx: number) => {
            return {
                ...rack,
                left: 10 + idx * 45,
                top: 20
            };
        });
    }

    // ===== Edit Mode =====
    public toggleEditMode() {
        this.isEditMode = !this.isEditMode;
        if (this.isEditMode) {
            // 편집모드 진입: 캔버스 랙 초기화 (absolute positioning)
            this.initCanvasRacks();
        } else {
            // 편집모드 종료: 변경사항이 있으면 확인
            if (this.editHasChanges) {
                if (!confirm('Unsaved changes will be lost. Exit edit mode?')) {
                    this.isEditMode = true;
                    return;
                }
                this.discardEditChanges();
            }
            // View mode도 canvasRacks 사용하므로 초기화
            this.initCanvasRacks();
        }
        this.service.render();
    }

    private initCanvasRacks() {
        // Single horizontal row (matching view mode layout)
        const paddingStart = 32;
        const spacingX = 280; // 260px card + 20px gap
        const startY = 32;
        this.canvasRacks = this.rackLayout.map((rack: any, idx: number) => {
            return {
                ...rack,
                canvasX: rack.canvas_x != null ? rack.canvas_x : (paddingStart + idx * spacingX),
                canvasY: rack.canvas_y != null ? rack.canvas_y : startY
            };
        });
    }

    // 노드 편집 시작
    public startEditNode(node: any, event?: Event) {
        if (!this.isEditMode) return;
        if (event) event.stopPropagation();
        const edited = this.editedNodes.get(node.id);
        this.editingNode = node;
        this.editNodeRack = edited ? edited.rack : (node.rack || '');
        this.editNodeUnitOrder = edited ? edited.unitOrder : String(this.itemUnitOrder(node) || '');
        this.service.render();
    }

    public closeEditNode() {
        this.editingNode = null;
        this.service.render();
    }

    public applyNodeEdit() {
        if (!this.editingNode) return;
        const nodeId = this.editingNode.id;
        this.editedNodes.set(nodeId, {
            rack: this.editNodeRack,
            unitOrder: this.editNodeUnitOrder
        });
        this.editHasChanges = true;

        // 로컬 rackLayout도 업데이트하여 UI에 반영
        this.updateLocalRackLayout(nodeId, this.editNodeRack, this.editNodeUnitOrder);
        this.editingNode = null;
        this.service.render();
    }

    private updateLocalRackLayout(nodeId: number, newRack: string, newUnitOrder: string) {
        this.updateLocalRackItem('node', nodeId, newRack, newUnitOrder);
    }

    private updateLocalRackItem(itemType: string, itemId: number, newRack: string, newUnitOrder: string) {
        const collectionName = itemType === 'device' ? 'devices' : 'nodes';
        let movedItem: any = null;
        for (const rack of this.rackLayout) {
            const collection = rack[collectionName] || [];
            const idx = collection.findIndex((item: any) => item.id === itemId);
            if (idx >= 0) {
                movedItem = {
                    ...collection[idx],
                    rack: newRack,
                    unit: newUnitOrder,
                    unit_order: parseInt(newUnitOrder) || 0,
                    item_type: itemType
                };
                collection.splice(idx, 1);
                this.refreshRackSummary(rack);
                this.syncCanvasRackSummary(rack);
                break;
            }
        }
        if (!movedItem) return;

        for (const rack of this.rackLayout) {
            if (rack.rack_id === newRack) {
                if (!rack[collectionName]) rack[collectionName] = [];
                rack[collectionName].push(movedItem);
                rack[collectionName].sort((a: any, b: any) => this.itemUnitOrder(a) - this.itemUnitOrder(b));
                this.refreshRackSummary(rack);
                this.syncCanvasRackSummary(rack);
                break;
            }
        }
    }

    private appendLocalRackDevice(device: any) {
        device.item_type = 'device';
        const rack = this.rackLayout.find((item: any) => item.rack_id === String(device.rack));
        if (rack) {
            if (!rack.devices) rack.devices = [];
            if (!rack.devices.some((item: any) => item.id === device.id)) {
                rack.devices.push(device);
                rack.devices.sort((a: any, b: any) => this.itemUnitOrder(a) - this.itemUnitOrder(b));
            }
            this.refreshRackSummary(rack);
        }

        const canvasRack = this.canvasRacks.find((item: any) => item.rack_id === String(device.rack));
        if (canvasRack && canvasRack !== rack) {
            if (!canvasRack.devices) canvasRack.devices = [];
            if (!canvasRack.devices.some((item: any) => item.id === device.id)) {
                canvasRack.devices.push(device);
                canvasRack.devices.sort((a: any, b: any) => this.itemUnitOrder(a) - this.itemUnitOrder(b));
            }
            this.refreshRackSummary(canvasRack);
        }
    }

    private replaceLocalRackDevice(device: any) {
        for (const rack of this.rackLayout) {
            rack.devices = (rack.devices || []).filter((item: any) => item.id !== device.id);
            this.refreshRackSummary(rack);
        }
        this.appendLocalRackDevice(device);
        this.initCanvasRacks();
        if (this.showRackPanel && this.panelRack) {
            this.panelRack = this.canvasRacks.find((rack: any) => rack.rack_id === String(device.rack)) || this.panelRack;
        }
    }

    private refreshRackSummary(rack: any) {
        const nodes = rack.nodes || [];
        const devices = rack.devices || [];
        rack.node_count = nodes.length;
        rack.device_count = devices.length;
        rack.item_count = nodes.length + devices.length;
    }

    private syncCanvasRackSummary(sourceRack: any) {
        const canvasRack = this.canvasRacks.find((rack: any) => rack.rack_id === sourceRack.rack_id);
        if (!canvasRack || canvasRack === sourceRack) return;
        canvasRack.node_count = sourceRack.node_count;
        canvasRack.device_count = sourceRack.device_count;
        canvasRack.item_count = sourceRack.item_count;
    }

    private findAvailableUnitOrder(
        rack: any,
        unitSize: number,
        preferredUnitOrder: number,
        excludeType: string = '',
        excludeId: number = 0
    ): number | null {
        const size = Math.max(1, Math.min(42, parseInt(String(unitSize)) || 1));
        const preferred = Math.max(1, Math.min(42, parseInt(String(preferredUnitOrder)) || 1));
        const items = [
            ...(rack.nodes || []).map((item: any) => ({ ...item, item_type: 'node' })),
            ...(rack.devices || []).map((item: any) => ({ ...item, item_type: 'device' }))
        ].filter((item: any) => !(item.item_type === excludeType && item.id === excludeId));
        const usedOrders = new Set<number>(items.map((item: any) => this.itemUnitOrder(item)));

        const canFit = (unitOrder: number) => {
            if (unitOrder < 1 || unitOrder > 42 || usedOrders.has(unitOrder)) return false;
            const candidates = [
                ...items,
                { id: -1, item_type: excludeType || 'node', unit_order: unitOrder, unit_size: size }
            ].sort((a: any, b: any) => this.itemUnitOrder(a) - this.itemUnitOrder(b));
            let extraUnits = 0;
            for (const item of candidates) {
                const order = this.itemUnitOrder(item);
                if (order < 1) continue;
                const end = order + extraUnits + this.itemUnitSize(item) - 1;
                if (end > 42) return false;
                extraUnits += this.itemUnitSize(item) - 1;
            }
            return true;
        };

        for (let delta = 0; delta <= 42; delta++) {
            const upward = preferred + delta;
            if (canFit(upward)) return upward;
            const downward = preferred - delta;
            if (delta > 0 && canFit(downward)) return downward;
        }
        return null;
    }

    private physicalUnitToOrder(rack: any, physicalUnit: number): number {
        const size = this.dragNode ? this.itemUnitSize(this.dragNode) : 1;
        const excludeType = this.dragItemType;
        const excludeId = this.dragNode?.id || 0;
        const items = [
            ...(rack.nodes || []).map((item: any) => ({ ...item, item_type: 'node' })),
            ...(rack.devices || []).map((item: any) => ({ ...item, item_type: 'device' }))
        ].filter((item: any) => !(item.item_type === excludeType && item.id === excludeId));
        const usedOrders = new Set<number>(items.map((item: any) => this.itemUnitOrder(item)));
        let bestOrder = Math.max(1, Math.min(42, physicalUnit));
        let bestDistance = Number.MAX_SAFE_INTEGER;

        for (let unitOrder = 1; unitOrder <= 42; unitOrder++) {
            if (usedOrders.has(unitOrder)) continue;
            const candidate = { id: -1, item_type: excludeType, unit_order: unitOrder, unit_size: size };
            const candidates = [...items, candidate].sort((a: any, b: any) => this.itemUnitOrder(a) - this.itemUnitOrder(b));
            let extraUnits = 0;
            let candidateStart = unitOrder;
            let valid = true;
            for (const item of candidates) {
                const order = this.itemUnitOrder(item);
                if (order < 1) continue;
                const start = order + extraUnits;
                const end = start + this.itemUnitSize(item) - 1;
                if (item.id === -1) candidateStart = start;
                if (end > 42) {
                    valid = false;
                    break;
                }
                extraUnits += this.itemUnitSize(item) - 1;
            }
            if (!valid) continue;
            const distance = Math.abs(candidateStart - physicalUnit);
            if (distance < bestDistance) {
                bestDistance = distance;
                bestOrder = unitOrder;
            }
        }
        return bestOrder;
    }

    public get editedRackItemCount(): number {
        return this.editedNodes.size + this.editedDevices.size;
    }

    public async saveEditChanges() {
        if (this.editedRackItemCount === 0 && !this.editHasChanges) return;
        this.editSaving = true;
        await this.service.render();

        // Save node positions
        if (this.editedRackItemCount > 0) {
            const nodeUpdates = Array.from(this.editedNodes.entries()).map(([nodeId, pos]) => ({
                id: nodeId,
                item_type: 'node',
                rack: pos.rack,
                unit_order: pos.unitOrder
            }));
            const deviceUpdates = Array.from(this.editedDevices.entries()).map(([deviceId, pos]) => ({
                id: deviceId,
                item_type: 'device',
                rack: pos.rack,
                unit_order: pos.unitOrder
            }));
            const { code } = await wiz.call("update_node_positions", {
                data: JSON.stringify([...nodeUpdates, ...deviceUpdates])
            });
            if (code !== 200) {
                alert('Failed to save node positions');
                this.editSaving = false;
                await this.service.render();
                return;
            }
        }

        // Save rack canvas positions
        const positions: any = {};
        for (const rack of this.canvasRacks) {
            positions[rack.rack_id] = { x: Math.round(rack.canvasX), y: Math.round(rack.canvasY) };
        }
        await wiz.call("save_rack_positions", {
            group_id: this.groupId,
            positions: JSON.stringify(positions)
        });

        this.editSaving = false;
        this.editedNodes.clear();
        this.editedDevices.clear();
        this.editHasChanges = false;
        // Reload
        await this.loadRackLayout();
        if (this.isEditMode) this.initCanvasRacks();
        await this.service.render();
    }

    public discardEditChanges() {
        this.editedNodes.clear();
        this.editedDevices.clear();
        this.editHasChanges = false;
        this.editingNode = null;
        // 원래 데이터로 복원
        this.loadRackLayout();
        this.service.render();
    }

    // 랙 드래그 (캔버스 모드)
    public onRackDragStart(event: MouseEvent, rack: any) {
        if (!this.isEditMode) return;
        event.preventDefault();
        event.stopPropagation();
        this.rackDragging = true;
        this.dragRackId = rack.rack_id;
        this.rackDragStartX = event.clientX;
        this.rackDragStartY = event.clientY;
        this.rackStartLeft = rack.canvasX;
        this.rackStartTop = rack.canvasY;
    }

    public onCanvasMouseMove(event: MouseEvent) {
        if (this.rackDragging && this.dragRackId) {
            const dx = (event.clientX - this.rackDragStartX) / this.fsScale;
            const dy = (event.clientY - this.rackDragStartY) / this.fsScale;
            const rack = this.canvasRacks.find((r: any) => r.rack_id === this.dragRackId);
            if (rack) {
                rack.canvasX = Math.max(0, this.rackStartLeft + dx);
                rack.canvasY = Math.max(0, this.rackStartTop + dy);
                this.service.render();
            }
            return;
        }
        if (this.nodeDragging) {
            this.nodeDragX = event.clientX;
            this.nodeDragY = event.clientY;
            // Detect which rack we're over
            const el = document.elementFromPoint(event.clientX, event.clientY);
            const rackCard = el?.closest('.rack-card') as HTMLElement;
            if (rackCard) {
                this.dragOverRackId = rackCard.getAttribute('data-rack-id');
                const targetRack = this.canvasRacks.find((rack: any) => rack.rack_id === this.dragOverRackId);
                const rackBody = rackCard.querySelector('.rack-body') as HTMLElement;
                if (rackBody) {
                    const rackSlot = el?.closest('.rack-slot') as HTMLElement;
                    if (rackSlot && rackCard.contains(rackSlot)) {
                        const exactUnitOrder = parseInt(rackSlot.getAttribute('data-unit-order') || '0');
                        const startUnit = parseInt(rackSlot.getAttribute('data-unit-start') || '0');
                        const endUnit = parseInt(rackSlot.getAttribute('data-unit-end') || '0');
                        if (exactUnitOrder > 0) {
                            this.dragOverUnitOrder = exactUnitOrder;
                        } else if (startUnit > 0 && endUnit >= startUnit) {
                            const slotRect = rackSlot.getBoundingClientRect();
                            const ratio = slotRect.height > 0
                                ? Math.max(0, Math.min(0.9999, (event.clientY - slotRect.top) / slotRect.height))
                                : 0;
                            const physicalUnit = endUnit - Math.floor(ratio * (endUnit - startUnit + 1));
                            if (targetRack) this.dragOverUnitOrder = this.physicalUnitToOrder(targetRack, physicalUnit);
                        }
                    } else {
                        const bodyRect = rackBody.getBoundingClientRect();
                        const relativeY = event.clientY - bodyRect.top + rackBody.scrollTop;
                        const totalHeight = rackBody.scrollHeight;
                        if (totalHeight > 0 && relativeY >= 0) {
                            const ratio = Math.max(0, Math.min(0.9999, relativeY / totalHeight));
                            const physicalUnit = 42 - Math.floor(ratio * 42);
                            if (targetRack) this.dragOverUnitOrder = this.physicalUnitToOrder(targetRack, physicalUnit);
                        }
                    }
                }
            } else {
                this.dragOverRackId = null;
                this.dragOverUnitOrder = 1;
            }
            this.service.render();
            return;
        }
        // 기존 뷰포트 패닝
        this.fsMouseMove(event);
    }

    public onCanvasMouseUp() {
        if (this.rackDragging) {
            this.rackDragging = false;
            this.dragRackId = null;
            this.editHasChanges = true;
            return;
        }
        if (this.nodeDragging) {
            this.finishNodeDrag();
            return;
        }
        this.fsMouseUp();
    }

    public onCanvasMouseDown(event: MouseEvent) {
        // 랙 카드 위가 아닌 경우만 뷰포트 패닝
        if ((event.target as HTMLElement).closest('.rack-card')) return;
        this.fsMouseDown(event);
    }

    public isNodeEdited(nodeId: number): boolean {
        return this.editedNodes.has(nodeId);
    }

    public isDeviceEdited(deviceId: number): boolean {
        return this.editedDevices.has(deviceId);
    }

    // Node drag & drop methods
    public onNodeDragStart(event: MouseEvent, node: any, rackId: string, itemType: string = 'node') {
        if (!this.isEditMode) return;
        event.preventDefault();
        event.stopPropagation();
        this.nodeDragging = true;
        this.dragNode = node;
        this.dragItemType = itemType;
        this.dragSourceRack = rackId;
        this.nodeDragStartX = event.clientX;
        this.nodeDragStartY = event.clientY;
        this.nodeDragX = event.clientX;
        this.nodeDragY = event.clientY;
    }

    private finishNodeDrag() {
        if (!this.nodeDragging || !this.dragNode) return;
        const draggedItem = this.dragNode;
        const targetRackId = this.dragOverRackId;
        const itemId = draggedItem.id;
        const itemType = this.dragItemType;
        const unitSize = this.itemUnitSize(draggedItem);
        const requestedUnitOrder = this.dragOverUnitOrder || 1;
        const sourceRack = this.dragSourceRack;

        this.nodeDragging = false;
        this.dragNode = null;
        this.dragItemType = 'node';
        this.dragSourceRack = '';
        this.dragOverRackId = null;

        if (targetRackId) {
            const targetRack = this.canvasRacks.find((r: any) => r.rack_id === targetRackId);
            if (targetRack) {
                const currentRack = String(draggedItem.rack || sourceRack);
                const currentUnitOrder = this.itemUnitOrder(draggedItem);
                const swapTarget = targetRackId === currentRack
                    ? [
                        ...(targetRack.nodes || []).map((item: any) => ({ ...item, item_type: 'node' })),
                        ...(targetRack.devices || []).map((item: any) => ({ ...item, item_type: 'device' }))
                    ].find((item: any) => {
                        if (item.item_type === itemType && item.id === itemId) return false;
                        return this.itemUnitOrder(item) === requestedUnitOrder;
                    })
                    : null;

                // Same-rack drops swap Unit Order values, including differently sized items.
                if (swapTarget) {
                    const swapType = swapTarget.item_type;
                    const swapEdits = swapType === 'device' ? this.editedDevices : this.editedNodes;
                    swapEdits.set(swapTarget.id, { rack: currentRack, unitOrder: String(currentUnitOrder) });
                    this.updateLocalRackItem(swapType, swapTarget.id, currentRack, String(currentUnitOrder));

                    const edits = itemType === 'device' ? this.editedDevices : this.editedNodes;
                    const swapUnitOrder = this.itemUnitOrder(swapTarget);
                    edits.set(itemId, { rack: targetRackId, unitOrder: String(swapUnitOrder) });
                    this.updateLocalRackItem(itemType, itemId, targetRackId, String(swapUnitOrder));
                    this.editHasChanges = true;
                    this.service.render();
                    return;
                }

                const targetUnitOrder = this.findAvailableUnitOrder(
                    targetRack,
                    unitSize,
                    requestedUnitOrder,
                    itemType,
                    itemId
                );
                if (targetUnitOrder === null) {
                    alert(`No valid Unit Order is available for this ${unitSize}U item in ${targetRack.name}.`);
                    this.service.render();
                    return;
                }

                if (targetRackId === currentRack && targetUnitOrder === currentUnitOrder) {
                    this.service.render();
                    return;
                }

                const edits = itemType === 'device' ? this.editedDevices : this.editedNodes;
                edits.set(itemId, { rack: targetRackId, unitOrder: String(targetUnitOrder) });
                this.editHasChanges = true;
                this.updateLocalRackItem(itemType, itemId, targetRackId, String(targetUnitOrder));
            }
        }
        this.service.render();
    }

    public getNodeEditRack(nodeId: number): string {
        const edit = this.editedNodes.get(nodeId);
        return edit ? edit.rack : '';
    }

    // Node hover tooltip
    public onNodeHover(event: MouseEvent, node: any) {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        this.hoverNode = node;
        this.hoverNodeX = event.clientX;
        this.hoverNodeY = event.clientY;
        this.service.render();
    }

    public onNodeHoverMove(event: MouseEvent) {
        if (!this.hoverNode) return;
        this.hoverNodeX = event.clientX;
        this.hoverNodeY = event.clientY;
    }

    public onNodeHoverLeave() {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        this.hoverTimeout = null;
        this.hoverNode = null;
        this.service.render();
    }

    // Rack side panel (View Detail)
    public openRackPanel(rack: any, event?: Event) {
        if (event) event.stopPropagation();
        this.panelRack = rack;
        this.showRackPanel = true;
        this.service.render();
    }

    public closeRackPanel() {
        this.showRackPanel = false;
        this.panelRack = null;
        this.service.render();
    }

    public toggleTheme() {
        this.fsTheme = this.fsTheme === 'dark' ? 'light' : 'dark';
        this.service.render();
    }

    public get isDarkTheme(): boolean {
        return this.fsTheme === 'dark';
    }

    // ===== Common =====
    public goBack() {
        this.service.href('/kiera/groups');
    }

    public totalPages() {
        return Math.ceil(this.nodeTotal / this.search.dump) || 1;
    }

    public pageRange() {
        const tp = this.totalPages();
        const current = this.search.page;
        const delta = 2;
        let start = Math.max(1, current - delta);
        let end = Math.min(tp, current + delta);
        if (end - start < delta * 2) {
            if (start === 1) end = Math.min(tp, start + delta * 2);
            else start = Math.max(1, end - delta * 2);
        }
        const pages = [];
        for (let i = start; i <= end; i++) pages.push(i);
        return pages;
    }
    public canManageResourceUsers() { return ['admin', 'superadmin'].includes(String(this.service.auth.session?.role || '').toLowerCase()); }
}

export default PageKieraGroupsItemComponent;
